import { render, staticRenderFns } from "./Psi_records.vue?vue&type=template&id=5a5f4562&"
import script from "./Psi_records.vue?vue&type=script&lang=js&"
export * from "./Psi_records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports